(() => {
  if (window.mettaV2FlavorTabsInitialized) return;
  window.mettaV2FlavorTabsInitialized = true;
  function sync(root) {
    if (!root) return;
    root.querySelectorAll('[data-v2-flavor-panel] [role="tab"]').forEach(tab => {
      const active = tab.getAttribute('aria-pressed') === 'true';
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
  }
  function init(scope = document) { scope.querySelectorAll('[data-v2-pdp]').forEach(sync); }
  // The PDP's direct click handler has updated the family before this bubbles.
  document.addEventListener('click', event => {
    const tab = event.target.closest?.('[data-v2-family], [data-v2-category]');
    if (tab) sync(tab.closest('[data-v2-pdp]'));
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest?.('[data-v2-flavor-panel] [role="tab"]');
    if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[next].focus();
    tabs[next].click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
